<div
  class="lib-input admin-form-field-outline admin-form-field-outline--shadow admin-form-field-outline--dynamic-height">
  @if (preIcon) {
    <span
      class="material-icons pre-icon">
      {{ preIcon }}
    </span>
  }
  @if (preSymbol) {
    <span
      class="pre-symbol">
      {{ preSymbol }}
    </span>
  }
  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="lib-input coin-form-field-outline {{ addClass ? 'coin-form-field-outline--' + addClass : '' }}"
    [ngClass]="inputIconClasses">
    @if (label) {
      <mat-label>
        {{ label }}
        <span>{{ errorMsg && '(' + errorMsg + ')' }}</span>
      </mat-label>
    }

    @if (!isNumber && !isInteger) {
      <input
        #input
        matInput
        autocomplete="off"
        [ngStyle]="{ 'text-align': textCenter ? 'center' : 'left' }"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [type]="type"
        [(ngModel)]="value"
        (keyup.enter)="onEnter()"
        (focus)="focusEnterLeave('enter')"
        (focusout)="focusEnterLeave('leave')" />
    }
    @if (isNumber || isInteger) {
      <input
        #input
        matInput
        [ngStyle]="{ 'text-align': textCenter ? 'center' : 'left' }"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [type]="type"
        [step]="isInteger ? 1 : 0.01"
        [(ngModel)]="value"
        (keyup.enter)="onEnter()"
        (focus)="focusEnterLeave('enter')"
        (focusout)="focusEnterLeave('leave')" />
    }
    <div
      #svgicon
    class="svg-icon"></div>
    <div
      #svgicon
    class="svg-icon"></div>
  </mat-form-field>
  @if (afterIcon) {
    <span
      class="material-icons after-icon"
      [ngClass]="{ presym: preSymbol }">
      {{ afterIcon }}
    </span>
  }
  @if (afterSymbol) {
    <span
      class="after-symbol">
      {{ afterSymbol }}
    </span>
  }
</div>
